module.exports = __webpack_public_path__ + "img/citySelect1.ed3331f9.png";